import React, { useContext } from 'react'
import cn from 'classnames'
import { TypeSectionUseCase } from '@lib/types/section-use-case'
import { PageSection } from '../../page-section'
import { ContentProps } from '../../renderer'
import { UseCaseTab, UseCaseTabs } from './tabs'
import styles from './use-case.module.scss'
import { PageContext } from '../../../contexts/page-context'
import { HOMEPAGE_OPTIMIZATION_SLUG, HOMEPAGE_SLUG } from '@lib/constants'
import { useBrowserService } from '@lib/hooks'

export const UseCaseSection: React.FC<ContentProps<TypeSectionUseCase>> = ({ className, structure }) => {
  const {
    sys,
    fields: { internalName, itemTab },
  } = structure
  const { slug } = useContext(PageContext)
  const { isMobile } = useBrowserService()

  const useCaseTabs: UseCaseTab[] = itemTab.map((item) => ({ title: item.fields.label, content: item.fields.content }))

  const isHomepageOptimization = slug === HOMEPAGE_OPTIMIZATION_SLUG || slug === HOMEPAGE_SLUG

  return (
    <PageSection
      internalName={internalName}
      sysStructure={sys}
      className={cn(className, styles.container, {
        [styles.reducedTopPadding]: isHomepageOptimization,
        [styles.reducedTopPaddingMobile]: isHomepageOptimization && isMobile,
      })}
    >
      <UseCaseTabs tabs={useCaseTabs} />
    </PageSection>
  )
}
